import { Injectable } from '@angular/core';
import { TranslationDaoService } from '../translation-dao.service';
import { KeyValuePersistenceService } from 'src/app/_services/persistence/key-value-persistence/key-value-persistence.service';

// CONSTANTS
const REMOTE_TRANSLATION_KEY = '_custom_translations';

@Injectable()
export class TranslationStorageDaoService implements TranslationDaoService {
  constructor(private keyValueStorage: KeyValuePersistenceService) {}

  public async saveTranslations(translations: Object): Promise<void> {
    await this.keyValueStorage.store(
      REMOTE_TRANSLATION_KEY,
      JSON.stringify(translations),
    );
  }

  public async getTranslations(): Promise<Object> {
    const trans =
      (await this.keyValueStorage.load(REMOTE_TRANSLATION_KEY)) ?? '{}';
    return JSON.parse(trans);
  }

  public async reset() {}

  public async clear() {
    await this.keyValueStorage.delete(REMOTE_TRANSLATION_KEY);
  }
}
